import Departments from './departments';

const normalizeText = (value) => String(value ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase();

const getDepartmentName = (department) => (
  department?.nome
  ?? department?.name
  ?? department?.descricao
  ?? department
);

const getDepartments = (user) => {
  if (Array.isArray(user)) {
    return user;
  }

  if (typeof user === 'string') {
    return user.split(';');
  }

  if (typeof user?.departments === 'string') {
    return user.departments.split(';');
  }

  return [
    ...(Array.isArray(user?.departments) ? user.departments : []),
    ...(Array.isArray(user?.setores) ? user.setores : []),
    ...(Array.isArray(user?.departamentos) ? user.departamentos : []),
    user?.department,
    user?.departamento,
    user?.setor,
  ].filter(Boolean);
};

// isSuperAdmin vem de GET /profile/permissoes (ver utils/acl/permissoes.js,
// localStorage "permissoesAdmin") - concedível/revogável por usuário no
// backend (controller/user.js), não mais um perfilId fixo. Antes desse
// campo existir, essa checagem comparava perfilId === '99' direto.
export const isAdmin = (user) => user?.isSuperAdmin === true;

export const isGestao = (user) => {
  const gestao = normalizeText(Departments.GESTAO);

  return getDepartments(user).some((department) => (
    normalizeText(getDepartmentName(department)) === gestao
    || normalizeText(getDepartmentName(department)) === 'gestao'
  ));
};

export const canAccessUsersArea = (user) => isAdmin(user);

export const canAccessSettingsArea = (user) => isAdmin(user) && isGestao(user);

export const canAccessAdminArea = canAccessSettingsArea;

export const canAccessContratosAssinadosArea = (user) => isAdmin(user) || isGestao(user);

export const canAccessPermissoesArea = canAccessContratosAssinadosArea;

export const getStoredUserAccess = () => ({
  perfilId: localStorage.getItem('perfilId'),
  isSuperAdmin: localStorage.getItem('permissoesAdmin') === 'true',
  departments: localStorage.getItem('departments') || '',
});
